import { collection, getDocs, query, where } from "firebase/firestore";
import React from "react";
import { db } from "../../../firebase";

const FetchAttendanceController = async (ClassID, CourseID) => {
  let temp = [];

  try {
    const AttendanceCollection = collection(db, "Attendance");
    const q = query(
      AttendanceCollection,
      where("IsDeleted", "==", false),
      where("ClassID", "==", ClassID),
      where("CourseID", "==", CourseID)
    );
    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      temp.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    return temp;
  } catch (error) {
    console.log(error);
  }
};

export default FetchAttendanceController;
